import { render, staticRenderFns } from "./SelecionaLayout.vue?vue&type=template&id=779338f3"
import script from "./SelecionaLayout.vue?vue&type=script&lang=js"
export * from "./SelecionaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports